import React from 'react';
import { PropTypes } from 'prop-types';

import ModalWrapper from 'components/Modals/ModalWrapper';

const DeleteFileModal = ({
  isShown,
  isDeletingFile,
  onConfirmDelete,
  onCancel,
  deleteFileError
}) => (
  <ModalWrapper
    headerClose={ false }
    isOpen={ isShown }
    title="Delete File"
    btnConfirmTitle="Delete"
    btnConfirmClass={ `btn-danger ${ isDeletingFile ? 'loading' : '' }` }
    btnCancelTitle="Cancel"
    onConfirm={ onConfirmDelete }
    onCancel={ onCancel }
  >
    <p>
      Are you sure you want to delete this File?
    </p>
    {
      deleteFileError
      && <div className="toast toast-error">
        { deleteFileError }
      </div>
    }
  </ModalWrapper>
);

DeleteFileModal.propTypes = {
  isShown: PropTypes.bool,
  isDeletingFile: PropTypes.bool,
  onConfirmDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  deleteFileError: PropTypes.string
};

DeleteFileModal.defaultProps = {
  isShown: false,
  isDeletingFile: false,
  deleteFileError: null
};

export default DeleteFileModal;
